import axios from 'axios'
import env from "../../env"

export const fetchSocialAppGoogle = (appId, category) => {  
  return (dispatch, getState) => {
      dispatch({ type: 'SET_LOADING', payload: true })
      axios({
          method:'get',
          url: `${env.REACT_APP_BE_URL}/socialData/${appId}/${category}`,
        })
          .then(response => {
            dispatch({ type: 'SET_SOCIAL_APP_GOOGLE', payload: response.data})
          })
          .catch(error => {
            dispatch({ type: 'SET_ERROR', payload: error})
          })
          .finally(_ => {
            dispatch({ type: 'SET_LOADING', payload: false })
          })
    }
}

export const fetchSocialAppFacebook = (appId, category) => {  
  return (dispatch, getState) => {
      dispatch({ type: 'SET_LOADING', payload: true })
      axios({
          method:'get',
          url: `${env.REACT_APP_BE_URL}/socialData/${appId}/${category}`,
        })
          .then(response => {
            dispatch({ type: 'SET_SOCIAL_APP_FACEBOOK', payload: response.data})    
          })
          .catch(error => {
            dispatch({ type: 'SET_ERROR', payload: error})
          })
          .finally(_ => {
            dispatch({ type: 'SET_LOADING', payload: false })
          })
    }
}

export const fetchSocialAppLinkedIn = (appId, category) => {  
  return (dispatch, getState) => {
      dispatch({ type: 'SET_LOADING', payload: true })
      axios({
          method:'get',
          url: `${env.REACT_APP_BE_URL}/socialData/${appId}/${category}`,
        })
          .then(response => {
            dispatch({ type: 'SET_SOCIAL_APP_LINKEDIN', payload: response.data})
          })
          .catch(error => {
            dispatch({ type: 'SET_ERROR', payload: error})
          })
          .finally(_ => {
            dispatch({ type: 'SET_LOADING', payload: false })
          })
    }
}


export const addUpdateSocialApp = (payload) => {
  return (dispatch, getState) => {
    axios({
      method:'post',
      url: `${env.REACT_APP_BE_URL}/auth/social/${payload.appId}`,
      headers: {
        authorization: `Bearer ${localStorage.getItem('access_token')}`
      },
      data: payload
    })
      .then(response => {
          dispatch({ type: 'SET_SOCIAL_APP', payload: response.data})
      })
      .catch(error => {
          dispatch({ type: 'SET_ERROR', payload: error })
      })
      .finally(_ => {
          dispatch({ type: 'SET_LOADING', payload: false })
      })
  }
}

export const updateSocialStatus = (payload) => {
  return (dispatch, getState) => {
    axios({
      method:'patch',
      url: `${env.REACT_APP_BE_URL}/auth/social/${payload.appId}/status`,
      headers: {
        authorization: `Bearer ${localStorage.getItem('access_token')}`
      },
      data: payload
    })
      .then(response => {
          dispatch({ type: 'SET_SOCIAL_APP', payload: response.data})
      })
      .catch(error => {
          dispatch({ type: 'SET_ERROR', payload: error })
      })
      .finally(_ => {
          dispatch({ type: 'SET_LOADING', payload: false })
      })
  }
}